export const VersionId = '{VersionId}';
export const SynonymPK = '{SynonymPK}';
export const GroupName = '{GroupName}';
export const EntryId = '{EntryId}';
